import React, { useState, useEffect } from "react";
import Widthcontainer from "../../components/customcomponents/widthcontainer";
import { getBlogComment } from "../../data/api";
import LoginModal from "../../components/pages/loginmodal";
import Token from "../../utils/useToken";
import { Modal, Form, Button } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";
import {
   createComment,
   createReply,
   deleteComment,
   deleteReply,
   likeComment,
   unlikeComment,
   updateComment,
} from "../../data/protectedapi";
import { format } from "date-fns";
import {
   AiOutlineHeart,
   AiFillHeart,
   AiFillCaretDown,
   AiFillCaretUp,
   AiFillDelete,
} from "react-icons/ai";
import { TiMessage } from "react-icons/ti";
import { Avatar } from "@mui/material";
import DishHomeLogo from "../../assets/logo.png";
import errorLogo from "../../assets/error.webp";
import { FaRegEdit } from "react-icons/fa";

export default function CommentSection({ id, setCommentLength, scrollRef }) {
   const { userDetails } = Token();
   const [isWaiting, setIsWaiting] = useState(false);
   const [comments, setComments] = useState([]);
   const [show, setShow] = useState(false);
   const [commentModal, setCommentModal] = useState(false);
   const [commentUpdateModal, setCommentUpdateModal] = useState(false);
   const [btnState, setbtnState] = useState(false);
   const [reloadComment, setReloadComment] = useState(true);
   const [commentDeleteModal, setCommentDeleteModal] = useState(false);
   const [commentId, setCommentId] = useState("");
   const [replyId, setReplyId] = useState("");
   const [replyDeleteModal, setReplyDeleteModal] = useState(false);

   useEffect(() => {
      async function getData() {
         const res = await getBlogComment(id);
         setComments(res?.data?.data);
         setCommentLength(res?.data?.data?.length);
         setIsWaiting(false);
      }
      getData();
   }, [reloadComment]);

   const schema = yup.object().shape({
      comment: yup
         .string()
         .required("Comment is required")
         .min(5, "Comment must me at least 5 characters ")
         .max(350),
   });

   const handleClose = () => {
      setCommentDeleteModal(false);
      setReplyDeleteModal(false);
   };

   const handleCommentDelete = async () => {
      if (!userDetails) {
         setShow(true);
         return;
      }
      const res = await deleteComment(commentId);
      if (res?.status === 200) {
         setReloadComment(!reloadComment);
      }
      handleClose();
   };

   const handleReplyDelete = async () => {
      if (!userDetails) {
         setShow(true);
         return;
      }
      const res = await deleteReply(commentId, replyId);
      if (res?.status === 200) {
         setReloadComment(!reloadComment);
      }
      handleClose();
   };

   const handleSubmit = async (values) => {
      setbtnState(true);
      const response = await createComment(id, {
         content: values?.comment,
      });
      if (response?.status === 201) {
         setCommentModal(false);
         setbtnState(false);
         setReloadComment(!reloadComment);
      } else {
         setbtnState(false);
      }
   };

   const handleCommentUpdate = async (values) => {
      setbtnState(true);
      const response = await updateComment(commentId, {
         content: values?.comment,
      });
      if (response?.status === 201) {
         setCommentUpdateModal(false);
         setbtnState(false);
         setReloadComment(!reloadComment);
      } else {
         setbtnState(false);
      }
   };

   const DeleteModel = ({ show, setShow }) => {
      return (
         <Modal show={show} onHide={() => setShow(false)} dialogClassName={"MessageModal"} centered>
            <Modal.Body>
               <div className="message_modal_wrapper">
                  <img src={errorLogo} alt="" height={80} width={80} />
                  <p className="add-to-cart-header"> Do yo wish to delete comment?</p>
                  <div id="modal-addcart-footer">
                     <Button
                        className="red"
                        variant="secondary"
                        id="addtocart-cart"
                        onClick={() => handleCommentDelete()}
                     >
                        Yes
                     </Button>
                     <Button
                        variant="primary"
                        id="continue-shopping"
                        onClick={() => setShow(false)}
                     >
                        Cancel
                     </Button>
                  </div>
               </div>
            </Modal.Body>
         </Modal>
      );
   };

   const ReplyDeleteModel = ({ show, setShow }) => {
      return (
         <Modal show={show} onHide={() => setShow(false)} dialogClassName={"MessageModal"} centered>
            <Modal.Body>
               <div className="message_modal_wrapper">
                  <img src={errorLogo} alt="" height={80} width={80} />
                  <p className="add-to-cart-header"> Do yo wish to delete the reply?</p>
                  <div id="modal-addcart-footer">
                     <Button
                        className="red"
                        variant="secondary"
                        id="addtocart-cart"
                        onClick={() => handleReplyDelete()}
                     >
                        Yes
                     </Button>
                     <Button
                        variant="primary"
                        id="continue-shopping"
                        onClick={() => setShow(false)}
                     >
                        Cancel
                     </Button>
                  </div>
               </div>
            </Modal.Body>
         </Modal>
      );
   };

   const [initialValues, setinitialValues] = useState({
      comment: "",
   });

   return (
      <>
         <Modal
            show={commentModal}
            onHide={() => {
               setCommentModal(false);
            }}
            dialogClassName="enterprise_section_container"
            centered
         >
            <Modal.Body
               style={{
                  display: "flex",
                  justifyContent: "center",
                  borderRadius: "12px",
                  paddingTop: "20px",
                  paddingBottom: "20px",
               }}
            >
               <Formik
                  validationSchema={schema}
                  onSubmit={handleSubmit}
                  initialValues={{
                     comment: "",
                  }}
               >
                  {({ handleSubmit, handleChange, values, touched, errors }) => (
                     <Form className="blogComment__formWrapper ps-4" onSubmit={handleSubmit}>
                        <div className="inputContainer">
                           <h3 className="title">Leave a Reply</h3>
                           <p className="sub__heading">Your email address will not be published</p>
                           <label htmlFor="remark">
                              Remark
                              <span className="text-danger">*</span>
                           </label>
                           <textarea
                              type="textarea"
                              name="comment"
                              className={errors?.comment ? "Remark_Input error" : "Remark_Input"}
                              value={values?.comment}
                              onChange={(e) => {
                                 if (e?.nativeEvent?.data) {
                                    if (
                                       e?.nativeEvent?.data?.toString()?.match("[0-9A-Za-z, \b]")
                                    ) {
                                       handleChange(e);
                                    }
                                    if (e?.nativeEvent?.data === null) {
                                       handleChange(e);
                                    }
                                 } else {
                                    handleChange(e);
                                 }
                              }}
                              minLength="5"
                              maxLength={"350"}
                              placeholder=""
                           />
                           {errors?.comment ? (
                              <p className="error_message" style={{ color: "#ed1c24" }}>
                                 {errors?.comment}
                              </p>
                           ) : null}
                        </div>
                        <div className="button_wrapper_modal">
                           <button
                              className={
                                 btnState ? "enterprise_button loading" : "enterprise_button "
                              }
                              type="submit"
                              disabled={btnState}
                           >
                              {btnState ? "Loading ..." : "Submit"}
                           </button>
                        </div>
                     </Form>
                  )}
               </Formik>
            </Modal.Body>
         </Modal>
         <Modal
            show={commentUpdateModal}
            onHide={() => {
               setCommentUpdateModal(false);
            }}
            dialogClassName="enterprise_section_container"
            centered
         >
            <Modal.Body
               style={{
                  display: "flex",
                  justifyContent: "center",
                  borderRadius: "12px",
                  paddingTop: "20px",
                  paddingBottom: "20px",
               }}
            >
               <Formik
                  validationSchema={schema}
                  onSubmit={handleCommentUpdate}
                  enableReinitialize={true}
                  initialValues={initialValues}
               >
                  {({ handleSubmit, handleChange, values, touched, errors }) => (
                     <Form className="blogComment__formWrapper ps-4" onSubmit={handleSubmit}>
                        <div className="inputContainer">
                           <h3 className="title">Update your comment</h3>
                           <label htmlFor="remark">
                              Comment
                              <span className="text-danger">*</span>
                           </label>
                           <textarea
                              type="textarea"
                              name="comment"
                              className={errors?.comment ? "Remark_Input error" : "Remark_Input"}
                              value={values?.comment}
                              onChange={(e) => {
                                 if (e?.nativeEvent?.data) {
                                    if (
                                       e?.nativeEvent?.data?.toString()?.match("[0-9A-Za-z, \b]")
                                    ) {
                                       handleChange(e);
                                    }
                                    if (e?.nativeEvent?.data === null) {
                                       handleChange(e);
                                    }
                                 } else {
                                    handleChange(e);
                                 }
                              }}
                              minLength="5"
                              maxLength={"350"}
                              placeholder=""
                           />
                           {errors?.comment ? (
                              <p className="error_message" style={{ color: "#ed1c24" }}>
                                 {errors?.comment}
                              </p>
                           ) : null}
                        </div>
                        <div className="button_wrapper_modal">
                           <button
                              className={
                                 btnState ? "enterprise_button loading" : "enterprise_button "
                              }
                              type="submit"
                              disabled={btnState}
                           >
                              {btnState ? "Loading ..." : "Submit"}
                           </button>
                        </div>
                     </Form>
                  )}
               </Formik>
            </Modal.Body>
         </Modal>
         <LoginModal Show={show} setShow={setShow} link={`/company/blogs/${id}`} />
         <DeleteModel show={commentDeleteModal} setShow={setCommentDeleteModal} />
         <ReplyDeleteModel show={replyDeleteModal} setShow={setReplyDeleteModal} />
         <Widthcontainer className={"Comment__Wrapper"}>
            <div className="comment__container fixed-width" ref={scrollRef}>
               <div className="addComment__btn__wrapper">
                  <div
                     className="addComment__btn"
                     onClick={() => {
                        !userDetails ? setShow(true) : setCommentModal(true);
                     }}
                  >
                     + &nbsp;Add Comment
                  </div>
               </div>
               {comments &&
                  Object.entries(comments)?.map(([key, value]) => {
                     return (
                        <CommentCard
                           data={value}
                           reloadComment={reloadComment}
                           setReloadComment={setReloadComment}
                           isWaiting={isWaiting}
                           setIsWaiting={setIsWaiting}
                           setLoginShow={setShow}
                           setCommentId={setCommentId}
                           setReplyId={setReplyId}
                           setCommentDeleteModal={setCommentDeleteModal}
                           setReplyDeleteModal={setReplyDeleteModal}
                           setCommentUpdateModal={setCommentUpdateModal}
                           setinitialValues={setinitialValues}
                        />
                     );
                  })}
            </div>
         </Widthcontainer>
      </>
   );
}

function CommentCard({
   data,
   setReloadComment,
   reloadComment,
   isWaiting,
   setIsWaiting,
   setLoginShow,
   setCommentId,
   setReplyId,
   setCommentDeleteModal,
   setReplyDeleteModal,
   setCommentUpdateModal,
   setinitialValues,
}) {
   const [isLiked, setIsLiked] = useState(false);
   const [adminLike, setAdminLike] = useState(false);
   const [isReplyOpen, setIsReplyOpen] = useState(false);
   const [isReplying, setIsReplying] = useState(false);
   const [childOpen, setChildOpen] = useState(false);
   const { userDetails } = Token();

   const schema = yup.object().shape({
      reply: yup
         .string()
         .required("Comment is required")
         .min(5, "Comment must me at least 5 characters ")
         .max(350),
   });

   useEffect(() => {
      let isLiked = false;
      let is_admin_like = false;
      for (const [key, value] of Object.entries(data?.like)) {
         if (value?.user_id?._id === userDetails?.id && !value?.is_admin_like) isLiked = true;
         if (value?.is_admin_like) is_admin_like = true;
      }
      if (isLiked) setIsLiked(true);
      else setIsLiked(false);
      if (is_admin_like) setAdminLike(true);
      else setAdminLike(false);
      // If no match is found, isLiked will remain false
   }, [data?.like?.length]);

   const handleLike = async () => {
      if (isWaiting) return;
      setIsWaiting(true);
      const res = await likeComment(data?._id);
      if (res?.status === 201) {
         setReloadComment(!reloadComment);
      }
   };

   const handleunLike = async () => {
      if (isWaiting) return;
      setIsWaiting(true);
      const res = await unlikeComment(data?._id);
      if (res?.status === 200) {
         setReloadComment(!reloadComment);
      }
   };
   const handleLikeUn = async () => {
      if (!userDetails) setLoginShow(true);
      if (isLiked) handleunLike();
      else handleLike();
   };

   const handleReply = async (values) => {
      console.log(data, values);
      if (!userDetails) {
         setLoginShow(true);
         return;
      }
      const res = await createReply(data?._id, { content: values?.reply });
      if (res?.status === 201) {
         setReloadComment(!reloadComment);
         setIsReplying(false);
         setChildOpen(false);
      }
      console.log(res);
   };

   return (
      <div className="commentCard">
         <div className="user_details">
            {data?.user_id?.profile_image || data?.is_admin_comment ? (
               <img
                  src={
                     data?.is_admin_comment
                        ? DishHomeLogo
                        : `${process.env.REACT_APP_FILE_URL}/${data?.user_id?.profile_image}`
                  }
                  height={38}
                  width={38}
                  style={
                     data?.is_admin_comment
                        ? {
                             borderRadius: "50%",
                             objectFit: "cover",
                             border: "none",
                          }
                        : { borderRadius: "50%", objectFit: "cover", border: "none" }
                  }
               />
            ) : (
               <Avatar
                  sx={{
                     bgcolor: "#C30C6B",
                     height: 38,
                     width: 38,
                  }}
                  style={{ fontSize: "16px", lineHeight: "24px" }}
               >
                  <span> {data?.user_id?.name?.charAt(0)}</span>
               </Avatar>
            )}
            <div className="details">
               <p
                  className="name"
                  style={data?.is_admin_comment ? { color: "#E5001C", fontWeight: "bold" } : {}}
               >
                  {data?.is_admin_comment ? "DishHome" : data?.user_id?.name}
               </p>
               <p className="date">
                  {format(new Date(data?.created_at), "MMMM dd, yyyy 'at' h:mm b")}
               </p>
            </div>
            {userDetails?.id === data?.user_id?._id && !data?.is_admin_comment && (
               <div className="action">
                  <AiFillDelete
                     onClick={() => {
                        setCommentId(data?._id);
                        setCommentDeleteModal(true);
                     }}
                  />
               </div>
            )}
            {userDetails?.id === data?.user_id?._id && !data?.is_admin_comment && (
               <div className="action ms-0 edit">
                  <FaRegEdit
                     onClick={() => {
                        setCommentId(data?._id);
                        setinitialValues({
                           comment: data?.content,
                        });
                        setCommentUpdateModal(true);
                     }}
                  />
               </div>
            )}
         </div>
         <div className="comment_content">
            <p className="blogComment__content">{data?.content}</p>
         </div>
         <div className="commentActions__container">
            <div className="icon__container">
               {isLiked ? (
                  <AiFillHeart
                     className="icon"
                     onClick={() => {
                        handleLikeUn();
                     }}
                  />
               ) : (
                  <AiOutlineHeart
                     className="icon"
                     onClick={() => {
                        handleLikeUn();
                     }}
                  />
               )}
               <p className="text">{data?.like?.length}</p>
            </div>
            <div
               className="icon__container"
               style={{ cursor: "pointer" }}
               onClick={() => (!userDetails ? setLoginShow(true) : setIsReplying(true))}
            >
               <TiMessage className="icon" />
               <p className="text">Reply</p>
            </div>
            {adminLike && (
               <div className="adminLikeContainer">
                  <img src={DishHomeLogo} height={20} className="dishhome" />
                  <AiFillHeart className="icon" color="#e61b2d" />
               </div>
            )}
         </div>
         {isReplying && (
            <ReplyInputBox
               schema={schema}
               handleReply={handleReply}
               setIsReplying={setIsReplying}
            />
         )}
         {data?.replies?.length > 0 && (
            <div className="repliesContainer">
               {data?.replies?.length > 0 && (
                  <div className="repliesCount" onClick={() => setIsReplyOpen(!isReplyOpen)}>
                     {isReplyOpen ? (
                        <AiFillCaretUp className="icon" />
                     ) : (
                        <AiFillCaretDown className="icon" />
                     )}
                     <p className="count">{data?.replies?.length} Replies</p>
                  </div>
               )}
               {isReplyOpen && (
                  <div className="replyBox__container">
                     {Object.entries(data?.replies)?.map(([key, value]) => {
                        return (
                           <ReplyBox
                              data={value}
                              schema={schema}
                              handleReply={handleReply}
                              childOpen={childOpen}
                              setChildOpen={setChildOpen}
                              userDetails={userDetails}
                              setLoginShow={setLoginShow}
                              commentId={data?._id}
                              setReplyId={setReplyId}
                              setCommentId={setCommentId}
                              setReplyDeleteModal={setReplyDeleteModal}
                           />
                        );
                     })}
                  </div>
               )}
            </div>
         )}
      </div>
   );
}

function ReplyInputBox({ schema, handleReply, setIsReplying }) {
   return (
      <Formik
         validationSchema={schema}
         onSubmit={handleReply}
         initialValues={{
            reply: "",
         }}
      >
         {({ handleSubmit, handleChange, values, touched, errors }) => (
            <Form className="replyingBox ps-4" onSubmit={handleSubmit}>
               <input
                  type="text"
                  name="reply"
                  required
                  className={errors?.reply ? "Remark_Input error" : "Remark_Input"}
                  value={values?.reply}
                  onChange={(e) => {
                     if (e?.nativeEvent?.data) {
                        if (e?.nativeEvent?.data?.toString()?.match("[0-9A-Za-z, \b]")) {
                           handleChange(e);
                        }
                        if (e?.nativeEvent?.data === null) {
                           handleChange(e);
                        }
                     } else {
                        handleChange(e);
                     }
                  }}
                  minLength="5"
                  maxLength={"350"}
                  placeholder=""
               />
               <button className="replySubmit" type="submit">
                  Reply
               </button>
               <button className="replySubmit" type="button" onClick={() => setIsReplying(false)}>
                  Cancle
               </button>
            </Form>
         )}
      </Formik>
   );
}

function ReplyBox({
   data,
   schema,
   handleReply,
   childOpen,
   setChildOpen,
   userDetails,
   setLoginShow,
   commentId,
   setCommentId,
   setReplyId,
   setReplyDeleteModal,
}) {
   const [isReplying, setIsReplying] = useState(false);
   return (
      <div className="replyBox">
         <div className="userDetails">
            {data?.user_id?.profile_image || data?.is_admin_reply ? (
               <img
                  src={
                     data?.is_admin_reply
                        ? DishHomeLogo
                        : `${process.env.REACT_APP_FILE_URL}/${data?.user_id?.profile_image}`
                  }
                  height={24}
                  width={24}
               />
            ) : (
               <Avatar
                  sx={{
                     bgcolor: "#C30C6B",
                     height: 24,
                     width: 24,
                  }}
                  style={{ fontSize: "12px", lineHeight: "24px" }}
               >
                  <span> {data?.user_id?.name?.charAt(0)}</span>
               </Avatar>
            )}
            <p
               className="name__text"
               style={data?.is_admin_reply ? { fontWeight: "bold", color: "#E5001C" } : {}}
            >
               {data?.is_admin_reply ? "DishHome" : data?.user_id?.name}
            </p>
            {userDetails?.id === data?.user_id?._id && !data?.is_admin_reply && (
               <div className="action">
                  <AiFillDelete
                     onClick={() => {
                        setCommentId(commentId);
                        setReplyId(data?._id);
                        setReplyDeleteModal(true);
                     }}
                  />
               </div>
            )}
            {userDetails?.id === data?.user_id?._id && !data?.is_admin_reply && (
               <div className="action ms-0 edit">
                  <FaRegEdit
                     onClick={() => {
                        setCommentId(commentId);
                        setReplyId(data?._id);
                     }}
                  />
               </div>
            )}
         </div>
         <div className="ReplyContent">
            <p className="content__">{data?.content}</p>
            <button
               className="replyBtn"
               type="button"
               onClick={() => {
                  if (!userDetails) setLoginShow(true);
                  else {
                     setIsReplying(true);
                     setChildOpen(true);
                  }
               }}
            >
               Reply
            </button>
            {isReplying && childOpen && (
               <ReplyInputBox
                  schema={schema}
                  handleReply={handleReply}
                  setIsReplying={setIsReplying}
               />
            )}
         </div>
      </div>
   );
}
